import React from "react";
import { Button } from "@progress/kendo-react-buttons";

export interface ComponentDialogProps {
  component: () => React.ReactNode;
  buttonText?: string;
  successText?: string;
  failureText?: string;
  onClick?: () => void;
  onSuccess?: () => void;
  onFailure?: () => void;
}

export function ComponentDialog(props: ComponentDialogProps) {
  return (
    <div className="">
      <div className="w-full flex items-end justify-end"></div>
      <div className="">{props.component()}</div>

      <div className="flex justify-end gap-4 pt-3">
        {props.onClick && (
          <Button
            className="buttonBackgroundColor"
            onClick={() => {
              if (props.onClick) {
                props.onClick();
              }
            }}
          >
            {props.buttonText && props.buttonText}
          </Button>
        )}

        {props.onSuccess && (
          <Button
            className="buttonBackgroundColor"
            onClick={() => {
              if (props.onSuccess) {
                props.onSuccess();
              }
            }}
          >
            {props.successText && props.successText}
          </Button>
        )}
        {props.onFailure && (
          <Button
            className="buttonBackgroundColor"
            onClick={() => {
              if (props.onFailure) {
                props.onFailure();
              }
            }}
          >
            {props.failureText && props.failureText}
          </Button>
        )}
      </div>
    </div>
  );
}
